import { NoticeBannerList, NoticeTopBanner } from 'noddi-web';
import { getNoticeBannerTranslations } from '../../utils/commonTranslations';
import { type CustomerTimePickerSurface } from './customerTimePickerSurface';
import { usePublishTimePickerSurface } from './timePickerNoticeSurfaceStore';
import { useCustomerNotices } from './useCustomerNotices';

type Props = {
  surface: CustomerTimePickerSurface;
  serviceDepartmentId?: number;
  addressId?: number;
  selectedSalesItemIds?: number[];
};

/** Opted-in notices, above the slots. Publishing the surface keeps them out of the page banner. Hidden when the fetch fails. */
export const CustomerTimePickerNotices = ({ surface, serviceDepartmentId, addressId, selectedSalesItemIds }: Props) => {
  usePublishTimePickerSurface(surface);
  const { isBrandPending, error, pickerContent, pickerTop } = useCustomerNotices({
    serviceDepartmentId,
    addressId,
    selectedSalesItemIds
  });

  if (isBrandPending || error || (pickerContent.length === 0 && pickerTop.length === 0)) {
    return null;
  }

  const translations = getNoticeBannerTranslations();

  return (
    <div className='flex flex-col gap-2'>
      <NoticeTopBanner notices={pickerTop} translations={translations} />
      <NoticeBannerList notices={pickerContent} translations={translations} />
    </div>
  );
};
